<div class="content-card">
  <alert message="MultipleAgreementGenerationWarning" alertType="error"></alert>
  @if (isLegalizationVisible && workerAgreementLegalizationData) {
  <div
    [visibleWithPermissions]="['LegalizationInformationVisibilityToAll', 'LegalizationInformationVisibilityToEmployerObjects']"
    class="content-card">
    <h2 class="content-card__header">{{ 'Legalization.LegalizationStatus' | translate }}</h2>
    <div class="workers-legalization-grid">
      @for (item of foreignWorkersWithData; track item.id; let i = $index) {
      <div>
        <app-legalization-status-info [element]="item.legalizationData" [size]="'large'" [showStatusText]="true"
          [showTooltip]="false" [showLabel]="true"
          [customLabel]="i + 1 + '. ' + item.name"></app-legalization-status-info>
      </div>
      }
    </div>
    <div>
      <button mat-raised-button class="legalization-status-btn" type="button"
        [matTooltip]="'Legalization.SubmitForMultipeLegalizationInfo' | translate"
        [matTooltipClass]="'line-broken-tooltip'" (click)="onSubmitForLegalization()">
        {{ 'Legalization.SubmitForLegalization' | translate }}
      </button>
    </div>
  </div>
  }
  <form [formGroup]="basicInformationStepFormGroup">
    <h2 class="content-card__header">{{ 'AEF-BasicInformation' | translate }}</h2>
    <div class="row">
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Company' | translate }}</mat-label>
          <mat-select [disabled]="this.isExtension" formControlName="company">
            <mat-select-trigger>{{ selectedCompanyName }}</mat-select-trigger>
            @if (isSyntheticSelectedCompany && selectedCompany && selectedCompany.Id === company.value) {
            <mat-option [value]="selectedCompany.Id">{{ selectedCompany.Name }}</mat-option>
            }
            @for (company of listOfCompanies$ | async; track company.Id) {
            <mat-option #matOption [value]="company.Id">{{ company.Name | translate }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Employer' | translate }}</mat-label>
          <mat-select formControlName="employer" #employerSelect>
            @for (employer of listOfEmployers$ | async; track employer.Id) {
            <mat-option #matOption [value]="employer.Id">{{
              employer.Name | translate
              }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'EmployerObject' | translate }}</mat-label>
          <input #employerObjectInput matInput formControlName="employerObject"
            placeholder="{{ 'EmployerObject' | translate }}" [matAutocomplete]="autocompleteEmployerObject" />
          <mat-autocomplete #autocompleteEmployerObject="matAutocomplete" [displayWith]="displayValue">
            @for (employerObject of listOfEmployerObjects$ | async; track employerObject.Id) {
            <mat-option [value]="employerObject">
              {{ employerObject.Name }}
            </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>

    @if (hasAccessToSupervisorJobTitle$ | async) {
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'SupervisorJobTitle' | translate }}</mat-label>
            <mat-select formControlName="supervisorJobTitle">
              <mat-option>
                <ngx-mat-select-search
                  [formControl]="supervisorJobTitleFilterCtrl"
                  [placeholderLabel]="'Search' | translate"
                  [noEntriesFoundLabel]="'SearchingNoResult' | translate"
                ></ngx-mat-select-search>
              </mat-option>
              @for (supervisorJobTitle of filteredSupervisorJobTitles$ | async; track $index) {
                <mat-option #matOption [value]="supervisorJobTitle.Id">
                  {{ supervisorJobTitle.Name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    }
    
    @if (orderItemActive && hasAssignOrderItemPermission) {
    <div class="row">
      <div class="col-6">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'OrderItem' | translate }}</mat-label>
          <mat-select formControlName="orderItem">
            @for (item of listOfAvailableOrderItems$ | async; track item.Id) {
            <mat-option #matOption [value]="item">{{ item.Name }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    }

    <div class="row">
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Location' | translate }}</mat-label>
          <input matInput formControlName="location" placeholder="{{ 'Location' | translate }}"
            [matAutocomplete]="autocompleteLocation" />
          <mat-autocomplete #autocompleteLocation="matAutocomplete" [displayWith]="displayValue">
            @for (location of listOfLocations$ | async; track location.Id) {
            <mat-option [value]="location">
              {{ location.Name }}
            </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'MPK' | translate }}</mat-label>
          <input matInput placeholder="{{ 'MPK' | translate }}" formControlName="mpk" autocomplete="given-name" />
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Workplace' | translate }}</mat-label>
          <input matInput formControlName="temporaryWorkplace" placeholder="{{ 'Workplace' | translate }}"
            [matAutocomplete]="autocompleteTemporaryWorkplace" />
          <mat-autocomplete #autocompleteTemporaryWorkplace="matAutocomplete" [displayWith]="displayValue">
            @for (temporaryWorkplace of listOfTemporaryWorkplaces$ | async; track temporaryWorkplace.Id) {
            <mat-option [value]="temporaryWorkplace">
              {{ temporaryWorkplace.Name }}
            </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="col">
		<mat-form-field *hasPermissionToModule="moduleNames.Supervisors" appearance="outline"> 
          <mat-label>{{ 'Supervisor' | translate }}</mat-label>
          <input matInput formControlName="supervisor" placeholder="{{ 'Supervisor' | translate }}"
            [matAutocomplete]="autocompleteSupervisor" />
          <mat-autocomplete #autocompleteSupervisor="matAutocomplete" [displayWith]="displayValue">
            @for (supervisor of listOfSupervisors$ | async; track supervisor.Id) {
            <mat-option [value]="supervisor">
              {{ supervisor.Name }}
            </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>

    <h2 class="content-card__header">{{ 'AgreementType' | translate }}</h2>

    <div class="row">
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'AgreementType' | translate }}</mat-label>
          <mat-select formControlName="agreementType">
            @for (agreementType of listOfAgreementTypes$ | async; track agreementType.Id) {
            <mat-option [value]="agreementType.Id">
              {{ agreementType.Name }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'AgreementConclusionDate' | translate }}</mat-label>
          <input matInput [matDatepicker]="pickConclusionDate" formControlName="conclusionDate" />
          <mat-datepicker-toggle matSuffix [for]="pickConclusionDate"></mat-datepicker-toggle>
          <mat-datepicker #pickConclusionDate></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'EmploymentDateFrom' | translate }}</mat-label>
          <input matInput [matDatepicker]="pickEmploymentDateFrom" formControlName="employmentDateFrom"
            [matDatepickerFilter]="employmentDateFromFilter" (dateChange)="checkDays('change', $event)" required />
          <mat-datepicker-toggle matSuffix [for]="pickEmploymentDateFrom"></mat-datepicker-toggle>
          <mat-datepicker #pickEmploymentDateFrom></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'EmploymentDateTo' | translate }}</mat-label>
          <input matInput [matDatepicker]="pickEmploymentDateTo" formControlName="employmentDateTo"
            [matDatepickerFilter]="employmentDateToFilter" (dateChange)="checkDays('change', $event)" />
          <mat-datepicker-toggle matSuffix [for]="pickEmploymentDateTo"></mat-datepicker-toggle>
          <mat-datepicker #pickEmploymentDateTo></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    @if (isPlannedPeriodSectionVisible) {
      <h2 class="content-card__header">{{ 'AEF-PlannedNextContractPeriod' | translate }}</h2>

      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'AEF-AgreementDurationValue' | translate }} ({{ nextContractDurationValueMin }}-{{ nextContractDurationValueMax }})</mat-label>
            <input matInput appNumbersOnly type="number" inputmode="numeric" step="1" [min]="nextContractDurationValueMin" [max]="nextContractDurationValueMax" formControlName="contractDurationValue" required />
            @if (contractDurationValue.hasError('required') && contractDurationValue.touched) {
              <mat-error>
                {{ 'RequiredField' | translate }}
              </mat-error>
            }
            @if (hasContractDurationValueValidationError) {
              <mat-error>
                {{ 'InvalidField' | translate }}
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'AEF-AgreementDurationUnit' | translate }}</mat-label>
            <mat-select formControlName="contractDurationUnit" required>
              @for (unit of contractDurationUnits; track unit) {
              <mat-option [value]="unit">
                {{ (unit === contractDurationUnitEnum.Month ? 'AEF-AgreementDurationMonth' : 'AEF-AgreementDurationYear') | translate:{ count: contractDurationValue.value || 1 } }}
              </mat-option>
              }
            </mat-select>
            @if (contractDurationUnit.hasError('required') && contractDurationUnit.touched) {
              <mat-error>
                {{ 'InvalidFieldSelect' | translate }}
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    }

    <div class="row">
      <div class="col">
        <mat-form-field appearance="outline" (click)="onOrganizationalUnitClick()">
          <mat-label>{{ 'OrganizationalUnit' | translate }}</mat-label>
          <input matInput formControlName="organizationalUnit" [matAutocomplete]="autocompleteOrganizationalUnit" />
          <mat-icon matSuffix>{{ 'expand_more' }}</mat-icon>
          <mat-autocomplete #autocompleteOrganizationalUnit="matAutocomplete" [displayWith]="displayValue">
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'JobTitle' | translate }}</mat-label>
          <mat-select formControlName="jobTitle">
            @for (jobTitle of listOfJobTitles$ | async; track jobTitle.Id) {
            <mat-option #matOption [value]="jobTitle.Id">{{
              jobTitle.Name | translate
              }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <app-responsibility-multi-select [control]="responsibilities"
          [filteredResponsibilities$]="filteredResponsibilities$" (filterChanged)="filterSubject.next($event)">
        </app-responsibility-multi-select>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <button class="float-right" mat-raised-button color="primary" (click)="submit()" matStepperNext>{{ 'Next' |
          translate }}</button>
      </div>
    </div>
  </form>
</div>
